import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RefreshService } from 'src/app/___LOGIC/__common/refresh.service';
import { ResolverService } from 'src/app/___LOGIC/__common/resolver.service';

@Component({
  selector: 'app-sub-app',
  templateUrl: './sub-app.component.html',
  styleUrls: ['./sub-app.component.css']
})
export class SubAppComponent implements OnInit {

  id: string;
  @Input() subAppName: string;
  @Input() subAppDescription: string;

  active;
  apps = [
    'visa-helper',
    'transport-helper',
    'accommodation-helper',
    'migration-helper',
    'health-helper',
    'budget-helper',
    'legal-helper'
  ];

  //flight-assistant

  constructor(private router: Router,private route: ActivatedRoute,private resolver: ResolverService, private refreshService: RefreshService) {
    this.id = this.route.snapshot.paramMap.get('id');
    console.log(this.id);
  }

  goBack() {
    this.router.navigate(['/home']);
  }

  ngOnInit(): void {
    if(this.id){
      this.active = this.id;
    }else{
      this.active = 'default'; 
    }

  }

  loading(){
    let fetching = this.refreshService.getCurrentFetchingQueries();
    for(let obj of fetching){
      if(this.resolver.isLoading(obj)){
        return true;
      }
    }
    return false;
  }

}
